import { LoadingOverlay } from '@mantine/core';
import { FC } from 'react';

interface LoadingProps {
  loading: boolean;
}

const Loading: FC<LoadingProps> = (props) => {
  return <LoadingOverlay visible={props.loading} zIndex={1000} overlayProps={{ blur: 2 }} />;
};

export default Loading;
